import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { AppBar, Box, Toolbar } from '@material-ui/core';
import {
  ThemeProvider as MuiThemeProvider,
  withStyles,
} from '@material-ui/core/styles';
import useIsMobileScreenState, {
  MEDIA_QUERIES,
} from 'modules/new-applications/hooks/useIsMobileScreenState';
import { muiTheme } from 'modules/shared/helpers/colorPalettes';
import React, { useState } from 'react';

import { MobileProgressDrawer } from './MobileProgressDrawer';
import OverlayButtonsList from './overlay-buttons';
import RoundButton from './RoundButton';
import SectionDrawer from './SectionDrawer';
import {
  ButtonGroup,
  HamburgerButton,
  Header,
  ImageContainer,
  Logo,
  LogoImage,
} from './styles';

const Overlay = (props) => {
  const [activeButton, setActiveButton] = useState(false);
  const {
    applicationChecklist,
    applicationId,
    currentSection,
    entityType,
    progressSections,
    supplierLogoUrl,
    supplierTerms,
    withButtons,
  } = props;

  const buttonList = OverlayButtonsList(applicationChecklist);

  const { isMobileScreen } = useIsMobileScreenState(
    MEDIA_QUERIES.max_width_991
  );

  const StyledAppBar = withStyles({
    root: {
      borderBottomLeftRadius: '5px',
      borderBottomRightRadius: '5px',
    },
  })(AppBar);

  return (
    <MuiThemeProvider theme={muiTheme()}>
      <Box>
        <StyledAppBar position="static" elevation={0}>
          <Header>
            <Toolbar>
              <Logo>
                <ImageContainer>
                  <LogoImage src={supplierLogoUrl} />
                </ImageContainer>
              </Logo>
              {withButtons && (
                <ButtonGroup>
                  {isMobileScreen && (
                    <HamburgerButton
                      type="button"
                      className={`button is-rounded is-outlined ${
                        activeButton === true ? 'active-button' : ''
                      }`}
                      onClick={() => setActiveButton(!activeButton)}
                    >
                      <FontAwesomeIcon
                        icon={['fas', 'bars']}
                        size={'lg'}
                        color="white"
                      />
                      <MobileProgressDrawer
                        activeButton={activeButton}
                        currentSection={currentSection}
                        entityType={entityType}
                        progressSections={progressSections}
                      />
                    </HamburgerButton>
                  )}
                  {buttonList.map(
                    ({ buttonName, buttonLabel }) =>
                      !isMobileScreen && (
                        <RoundButton
                          key={buttonName}
                          label={buttonLabel}
                          sideBarName={buttonName}
                        />
                      )
                  )}
                </ButtonGroup>
              )}
            </Toolbar>
          </Header>
        </StyledAppBar>
        <SectionDrawer
          applicationChecklist={applicationChecklist}
          applicationId={applicationId}
          currentSection={currentSection}
          entityType={entityType}
          progressSections={progressSections}
          supplierTerms={supplierTerms}
        />
      </Box>
    </MuiThemeProvider>
  );
};

Overlay.defaultProps = {
  withButtons: true,
};

export default Overlay;
